import { ContainerT } from 'lib/layout/provider/backend';

export const getContainerFromParams = (
    budgetProposalId?: string,
): ContainerT => (budgetProposalId === undefined ? 'dashboard' : 'argument');
